export const portfolioProjects = [
  {
    id: 'aiober',
    name: 'Aiober',
    description: 'Python framework for scalable Viber bots with async support and easy API integration.',
    tags: ['Open Source', 'SDK', 'Python'],
    icon: 'ri-robot-2-line',
    color: '#00D9FF',
    links: [
      { type: 'github', url: 'https://github.com/quaronsoftware/aiober', label: 'GitHub' }
    ],
  },
  {
    id: 'karum',
    name: 'Karum',
    description: 'Financial tracker that combines crypto wallets and bank accounts in one unified dashboard.',
    tags: ['Open Source', 'Fintech', 'MVP', 'New'],
    icon: 'ri-coin-line',
    color: '#F59E0B',
    links: [
      { type: 'github', url: 'https://github.com/QuaronSoftware/karum-finance', label: 'GitHub' }
    ],
  },
  {
    id: 'bookflow',
    name: 'BookFlow',
    description: 'Booking system for services with appointments, scheduling, and automated reminders.',
    tags: ['MVP', 'Free'],
    icon: 'ri-calendar-check-line',
    color: '#8B5CF6',
    links: [
      { type: 'telegram', url: 'https://t.me/bookflow_robot', label: 'Telegram' },
    ],
  },
  {
    id: 'allix',
    name: 'Allix',
    description: 'Something big is coming. Stay tuned for our next breakthrough project.',
    tags: ['Coming Soon'],
    icon: 'ri-question-mark',
    color: '#EC4899',
    links: [
      { type: 'telegram', url: 'https://t.me/notGucuL', label: 'Telegram' },
    ],
  },
];

export const services = [
  {
    id: 'bots',
    title: 'Bot Development',
    description: 'Telegram, Viber, Discord bots with custom logic and integrations.',
    icon: 'ri-robot-2-line',
    gradient: 'from-neon-blue to-neon-cyan',
  },
  {
    id: 'automation',
    title: 'Business Automation',
    description: 'Save time and reduce manual work with intelligent automated workflows.',
    icon: 'ri-settings-3-line',
    gradient: 'from-neon-purple to-neon-pink',
  },
  {
    id: 'webdev',
    title: 'Web Development',
    description: 'Websites, platforms, online stores with modern tech stacks.',
    icon: 'ri-code-s-slash-line',
    gradient: 'from-green-500 to-emerald-400',
  },
  {
    id: 'hosting',
    title: 'Hosting & Support',
    description: 'We host and support your projects so you can focus on growth.',
    icon: 'ri-server-line',
    gradient: 'from-orange-500 to-yellow-400',
  },
];

export const howWeWorkSteps = [
  {
    id: 1,
    title: 'Planning & Requirements',
    description: 'We start by understanding your business needs, goals, and technical constraints.',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 2,
    title: 'Architecture & System Design',
    description: 'We design scalable, maintainable architecture tailored to your specific requirements.',
    icon: 'ri-layout-masonry-line',
  },
  {
    id: 3,
    title: 'UI/UX Design',
    description: 'We create intuitive, visually stunning interfaces that users love.',
    icon: 'ri-paint-brush-line',
  },
  {
    id: 4,
    title: 'Development',
    description: 'We build your product with clean, efficient code using modern technologies.',
    icon: 'ri-code-box-line',
  },
  {
    id: 5,
    title: 'Testing & QA',
    description: 'Rigorous testing ensures your product works flawlessly across all scenarios.',
    icon: 'ri-bug-line',
  },
  {
    id: 6,
    title: 'Deployment',
    description: 'We deploy to production with monitoring, CI/CD, and zero-downtime strategies.',
    icon: 'ri-rocket-line',
  },
  {
    id: 7,
    title: 'Support & Scaling',
    description: 'Continuous support, performance monitoring, and scaling as your business grows.',
    icon: 'ri-line-chart-line',
  },
];

export const teamMembers = [
  {
    id: 'nazar',
    name: 'Nazar',
    nickname: 'Gucul',
    role: 'Founder & Lead Developer',
    image: 'https://storage.readdy-site.link/project_files/cda64c73-0cd6-4b91-8a57-da1fc108f4d8/c0ab2606-07b8-43b1-adc0-5c99881e92ba_IMG000-2.jpg?v=6cd6b7d76c30a4be2ca76967bc686a3a',
    socials: [
      { type: 'github', url: 'https://github.com/EvenEasy' },
      { type: 'linkedin', url: 'https://www.linkedin.com/in/nazarklymchuk' },
    ],
  },
  {
    id: 'roman',
    name: 'Roman',
    nickname: 'Majyk',
    role: 'Co-Founder & Creative Director',
    image: 'https://storage.readdy-site.link/project_files/cda64c73-0cd6-4b91-8a57-da1fc108f4d8/a76fbffa-517d-40d2-a1cc-710482ca198f_IMG_20260504_133628.jpg?v=9ae973097e9d95b3c3a30c45a30f881f',
    socials: [
      { type: 'linkedin', url: 'https://www.linkedin.com/in/roman-k-6b488137b/' },
    ],
  },
];
